import { render, staticRenderFns } from "./Regimen.vue?vue&type=template&id=df1b77da"
import script from "./Regimen.vue?vue&type=script&lang=js"
export * from "./Regimen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports